// extracted by mini-css-extract-plugin
export default {"formBody":"ProsperLoanTab_formBody__wAbm6","text":"ProsperLoanTab_text__P+geP","button":"ProsperLoanTab_button__EQdTO"};